module.exports = __webpack_public_path__ + "img/virgin_islands_us.1fddece.webp";